var map = {
	"./Star-Beginner.png": "0974",
	"./Star-Billionaire.png": "74ac",
	"./Star-Boss.png": "20d2",
	"./Star-Master.png": "9d25",
	"./Star-Millionaire.png": "4785",
	"./Star-Professional.png": "fd6c",
	"./Star-Rookie.png": "5b60",
	"./Star-Trillionaire.png": "9dfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6362";